// Every top-level column on the `customers` table that can be requested by
// `exportCustomersCsv`. Shared between the backend usecase (single source of
// truth via a `satisfies` check against the Drizzle schema) and the CRM
// frontend (multi-select).
export const CUSTOMER_CSV_FIELDS = [
  'id',
  'email',
  'firstName',
  'lastName',
  'externalCustomerId',
  'lastOrderId',
  'accountId',
  'storeId',
  'billingAddress',
  'shippingAddress',
  'currency',
  'locale',
  'draft',
  'acceptsMarketing',
  'createdAt',
  'updatedAt',
  'activatedAt',
  'lastActivityAt',
  'tags',
  'metadata',
] as const;

export type CustomerCsvField = (typeof CUSTOMER_CSV_FIELDS)[number];

// Sensible defaults for the CRM "export" multi-select.
export const CUSTOMER_CSV_FIELDS_ESSENTIALS: readonly CustomerCsvField[] = [
  'id',
  'email',
  'firstName',
  'lastName',
  'createdAt',
  'storeId',
  'currency',
  'lastOrderId',
];
